module.exports = __webpack_public_path__ + "media/images/clothes3-429213ab977b5d4ab23640ed02fa81ed.jpg";